import constants from '../shared/constants';

document.addEventListener('DOMContentLoaded', fadeInEffect);

function fadeInEffect(): void {
    const fadeTarget = document.documentElement;
    fadeTarget.classList.remove(constants.classes.nojs);
}
